import { useHttp, useTranslate } from '@/shared/lib'
import { useMutation, useQuery } from '@tanstack/vue-query'
import { computed, type Ref } from 'vue'
import { useNotification } from '@/shared/ui'

/**
 * Функция загрузки данных для виджета защитные автоматы
 */
export const useLoadControlWidget = (cabinet_id: Ref<number>) => {
  const http = useHttp()

  const url = computed(() => `/cabinets/${cabinet_id.value}/monitoring/control`)

  const queryKey = computed(() => ['load_control_widget', cabinet_id])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}

/**
 * Функция отправки команд управления
 */
export const useSendControlWidgetCommand = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => http.post(`/cabinets/monitoring/control`, data),
  })

  const send = async (contactor: number, type: string, value: number, object_id: number) => {
    try {
      await mutation.mutateAsync({ contactor, type, value, object_ids: [object_id] })

      addSuccess(trs('itf.command_send'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    send,
  }
}
